var s = Object.defineProperty;
var l = (n, r, e) => r in n ? s(n, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[r] = e;
var i = (n, r, e) => (l(n, typeof r != "symbol" ? r + "" : r, e), e);
import { APIFilterOperator as t, APIFilterCondition as p } from "./types.mjs";
class d {
  constructor(r, e) {
    i(this, "propertyName");
    i(this, "parentBuilder");
    this.propertyName = e, this.parentBuilder = r;
  }
  has(r) {
    return this.parentBuilder.recentPropertyOperator = t.Has, this.parentBuilder.addFilter(
      this.propertyName,
      Array.isArray(r) ? r.map((e) => `${t.Has}:${e}`) : `${t.Has}:${r}`
    );
  }
  in(r) {
    const e = Array.isArray(r) ? r : [r];
    return this.parentBuilder.recentPropertyOperator = t.In, this.parentBuilder.addFilter(
      this.propertyName,
      `${t.In}:${e.join(",")}`
    );
  }
  greaterThan(r) {
    return this.parentBuilder.recentPropertyOperator = t.GT, this.parentBuilder.addFilter(
      this.propertyName,
      `${t.GT}:${r}`
    );
  }
  greaterThanOrEqual(r) {
    return this.parentBuilder.recentPropertyOperator = t.GTE, this.parentBuilder.addFilter(
      this.propertyName,
      `${t.GTE}:${r}`
    );
  }
  lessThan(r) {
    return this.parentBuilder.recentPropertyOperator = t.LT, this.parentBuilder.addFilter(
      this.propertyName,
      `${t.LT}:${r}`
    );
  }
  lessThanOrEqual(r) {
    return this.parentBuilder.recentPropertyOperator = t.LTE, this.parentBuilder.addFilter(
      this.propertyName,
      `${t.LTE}:${r}`
    );
  }
  null() {
    return this.parentBuilder.recentPropertyOperator = t.Null, this.parentBuilder.addFilter(
      this.propertyName,
      t.Null
    );
  }
  notNull() {
    return this.parentBuilder.recentPropertyOperator = t.NotNull, this.parentBuilder.addFilter(
      this.propertyName,
      t.NotNull
    );
  }
  notIn(r) {
    const e = Array.isArray(r) ? r : [r];
    return this.parentBuilder.recentPropertyOperator = t.NotIn, this.parentBuilder.addFilter(
      this.propertyName,
      `${t.NotIn}:${e.join(",")}`
    );
  }
  andBitwise(r) {
    return this.parentBuilder.addFilter(
      this.propertyName,
      `${t.And}:${r}`
    );
  }
}
class c {
  constructor() {
    i(this, "operatorBuildPending");
    i(this, "conditionBuildPending");
    i(this, "recentPropertyName");
    i(this, "recentPropertyOperator");
    i(this, "filters", {});
  }
  addProperty(r) {
    if (this.operatorBuildPending === !0)
      throw new Error("API Filter operator configuration is incomplete");
    return this.operatorBuildPending = !0, this.recentPropertyName = r, new d(this, r);
  }
  addFilter(r, e) {
    if (this.filters[r]) {
      const o = this.filters[r], a = Array.isArray(e) ? e : [e];
      this.filters[r] = Array.isArray(o) ? o.concat(a) : [o, ...a];
    } else
      this.filters[r] = e;
    return this.operatorBuildPending = !1, this.conditionBuildPending = !1, this;
  }
  build() {
    return this.filters;
  }
  or() {
    if (this.operatorBuildPending === !0)
      throw new Error("API Filter operator configuration is incomplete");
    if (this.conditionBuildPending === !0)
      throw new Error("API Filter condition configuration is incomplete");
    if (!this.recentPropertyOperator || ![
      t.GT,
      t.GTE,
      t.LT,
      t.LTE,
      t.In,
      t.Has
    ].includes(this.recentPropertyOperator))
      throw new Error("Last operator not compatible for OR condition");
    const r = this.filters[this.recentPropertyName];
    if (Array.isArray(r))
      throw new Error("Last operator not compatible for OR condition");
    const e = `${r}:${p.Or}`;
    return this.filters[this.recentPropertyName] = e, this.conditionBuildPending = !0, this;
  }
}
export {
  c as default
};
